import request from './../utils/request'


export function index(params) {
  	return request({
  	  url: '/cities',
  	  method: 'get',
        params
  	})
  }
 
  export function inventory(params) {
    return request({
      url: '/cities/inventory',
      method: 'get',
      params
    })
  }

export function show(id) {
    return request({
      url: `/cities/${id}`,
      method: 'get'
    })
  }

  export function store(data) {
    return request({
      url: '/cities',
      method: 'post',
      data
    })
  }

  export function update(data) {
    return request({
      url: `/cities/${data.id}`,
      method: 'put',
      data
    })
  }

  export function destroy(id) {
    return request({
      url: `/cities/${id}`,
      method: 'delete',
    })
  }
